import React, { useState, useEffect } from 'react';
import Graph from "./Graph";
import Table from "./Table";
import { SERVER_URL } from '../../../Config';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

const Transactionhistory = () => {

  const [userData, setuserData] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [debitedAmount, setDebitedAmount] = useState(0);
  const [creditedAmount, setUserCreditedAmount] = useState(0);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [UserAccounts, setUserAccounts] = useState([]);
  const [showLoader, setshowLoader] = useState(false)

  const navigate = useNavigate();

  const getUserdatas = async () => {
    try {
      setshowLoader(true);
      const token = sessionStorage.getItem('_token');
      if (!token) {
        toast.error('Session Expired');
        navigate('/Login');
        return;
      }

      const decodedToken = jwtDecode(token);
      const res = await axios.get(`${SERVER_URL}/api/getUserdatas?AppID=${decodedToken.AppID}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status) {

        setuserData(res.data.User);
        setUserAccounts(res.data.accounts)
        const choosedAccount = sessionStorage.getItem('selectedAccount');

        if (!choosedAccount) {
          setSelectedAccount(res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null);
          sessionStorage.setItem('selectedAccount', res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null)
        } else {
          setSelectedAccount(sessionStorage.getItem('selectedAccount'))
        }
      } else {
        setuserData([]);
        setSelectedAccount(null);
      }
      setshowLoader(false);
    } catch (error) {
      console.error('Error fetching user data:', error);

      if (error.response?.status === 403) {
        toast.error('Session expired');
        navigate('/Login');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
      setshowLoader(false);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem('_token');
    if (token) {
      getUserdatas();
    }
  }, [sessionStorage.getItem('_token')]);

  const getUserTransactions = async (app_id) => {
    try {
      setshowLoader(true);
      const res = await axios.get(`${SERVER_URL}/api/transaction?app_id=${app_id}`);

      if (res.data.status) {
        const transactions = res.data.transactions;

        let totalDebited = 0;
        let totalCredited = 0;

        transactions.forEach((txn) => {
          if (txn.from_id === app_id) {
            totalDebited += Number(txn.amount);
          }
          if (txn.to_id === app_id) {
            totalCredited += Number(txn.amount);
          }
        });
        setTotalTransactions(transactions?.length ?? 0)
        setDebitedAmount(Number(totalDebited).toFixed(2));
        setUserCreditedAmount(Number(totalCredited).toFixed(2));
        setshowLoader(false);
      } else {
        console.error("Error fetching transactions:", res.data.message);
        setshowLoader(false);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setshowLoader(false);
    }
  };

  useEffect(() => {
    if (userData?.app_id) {
      getUserTransactions(userData.app_id);
      getLastThreeMonthsData(userData.app_id);
      checkSubscription(userData.app_id);
    }
  }, [userData]);

  const [monthlyData, setMonthlyData] = useState([]);
  const [debitPercent, setDebitPercent] = useState(0);
  const [creditPercent, setCreditPercent] = useState(0);
  const [transPercent, setTransPercent] = useState(0);

  const getLastThreeMonthsData = async (app_id) => {
    try {
      setshowLoader(true);
      const res = await axios.get(`${SERVER_URL}/api/getMonthlyTransactions?app_id=${app_id}`);

      if (res.data.status) {
        const data = res.data.data;
        setMonthlyData(data);

        const sortedData = data.sort((a, b) => new Date(b.month) - new Date(a.month));

        if (sortedData.length < 2) {
          console.log("Not enough data for comparison.");
          return;
        }

        const latestMonthData = sortedData[0];
        const previousMonthData = sortedData[1];

        const calculatePercentage = (current, previous) => {
          if (previous === 0) return current > 0 ? 100 : 0;
          return ((current - previous) / previous) * 100;
        };

        const debitedChange = calculatePercentage(
          parseFloat(latestMonthData.total_debited),
          parseFloat(previousMonthData.total_debited)
        );

        const creditedChange = calculatePercentage(
          parseFloat(latestMonthData.total_credited),
          parseFloat(previousMonthData.total_credited)
        );

        const transactionsChange = calculatePercentage(
          latestMonthData.total_transactions,
          previousMonthData.total_transactions
        );
        setDebitPercent(debitedChange.toFixed(2));
        setCreditPercent(creditedChange.toFixed(2));
        setTransPercent(transactionsChange.toFixed(2));
        setshowLoader(false);

      } else {
        console.error("Error fetching monthly transactions:", res.data.message);
        setshowLoader(false);

      }
    } catch (error) {
      console.error("Error fetching monthly transactions:", error);
      setshowLoader(false);

    }
  };

  const handleSubscribe = async () => {
    if (!email) {
      toast.error("Please enter your email!");
      return;
    }

    try {
      const response = await axios.post(`${SERVER_URL}/api/notifyuser`, { email });

      if (response.data.success) {
        toast.success("We will notify you");
        setShowModal(false);
        setEmail("");
      }
    } catch (error) {
      console.error(error);

      if (error.response && error.response.status === 409) {
        toast.error("Email already added!");
        setShowModal(false)
      } else {
        toast.error("Failed to subscribe. Try again!");
      }
    }
  };

  const checkSubscription = async (app_id) => {
    try {
      const res = await axios.get(`${SERVER_URL}/api/checknotify?app_id=${app_id}`);

      if (res.data.isSubscribed) {
        setIsSubscribed(true);
      } else {
        setIsSubscribed(false);
      }
    } catch (error) {
      console.error("Error checking subscription:", error);
      setIsSubscribed(false);
    }
  };

  return (
    <div className="w-full bg-[#060606] relative h-screen overflow-hidden overflow-y-auto text-white font-poppins ">
      <div
        className="z-0 absolute -top-36 left-0 right-0 w-[90%] mx-auto h-96 opacity-30 z-0 "
        style={{ background: "radial-gradient(50% 50% at 50% 50%, #FFF2C2 0%, rgba(0, 0, 0, 0) 100%)", }}   ></div>
      <div className="py-10 text-white font-inter ">
        <div className="pb-5 px-5 w-[100%] mx-auto">
          <p className="font-Artemus text-xl uppercase ">Transaction history</p>
          <hr className=" border border-[#856E4F] w-7 " />
        </div>
        <div className="w-[100%] mx-auto flex lg:flex-row flex-col justify-between items-center gap-5">
          <div className="lg:w-1/4 w-[95%] z-10 mx-auto bg-[#1D1D1C] h-32 rounded-2xl py-5 px-10 flex flex-col justify-between gap-5">
            <div className="font-bold">
              <p>Total Sent</p>
            </div>
            <div className="flex justify-between items-end h-full">
              <p className="text-3xl font-semibold">{debitedAmount}</p>
              <p
                className={`text-sm font-medium ${debitPercent >= 0 ? "text-green-500" : "text-red-500"
                  }`}
              >
                {debitPercent >= 0 ? `+${debitPercent}%` : `${debitPercent}%`}{" "}
                <span>
                  <i
                    className={`fa-solid ${debitPercent >= 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"
                      }`}
                  ></i>
                </span>
              </p>
            </div>
          </div>

          <div className="lg:w-1/4 w-[95%] z-10 mx-auto bg-[#1D1D1C] h-32 rounded-2xl py-5 px-10 flex flex-col justify-between gap-5">
            <div className="font-bold">
              <p>Total Received</p>
            </div>
            <div className="flex justify-between items-end h-full">
              <p className="text-3xl font-semibold">{creditedAmount}</p>
              <p
                className={`text-sm font-medium ${creditPercent >= 0 ? "text-green-500" : "text-red-500"
                  }`}
              >
                {creditPercent >= 0 ? `+${creditPercent}%` : `${creditPercent}%`}{" "}
                <span>
                  <i
                    className={`fa-solid ${creditPercent >= 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"
                      }`}
                  ></i>
                </span>
              </p>
            </div>
          </div>

          <div className="lg:w-1/4 w-[95%] z-10 mx-auto bg-[#1D1D1C] h-32 rounded-2xl py-5 px-10 flex flex-col justify-between gap-5">
            <div className="font-bold">
              <p>Total Transactions</p>
            </div>
            <div className="flex justify-between items-end h-full">
              <p className="text-3xl font-semibold">{totalTransactions}</p>
              <p
                className={`text-sm font-medium ${transPercent >= 0 ? "text-green-500" : "text-red-500"
                  }`}
              >
                {transPercent >= 0 ? `+${transPercent}%` : `${transPercent}%`}{" "}
                <span>
                  <i
                    className={`fa-solid ${transPercent >= 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"
                      }`}
                  ></i>
                </span>
              </p>
            </div>
          </div>

          <div className="lg:w-1/4 w-[95%] mx-auto bg-[#FFFFD940] h-32 rounded-2xl p-5 z-20">
            <p style={{ backgroundClip: "text", WebkitBackgroundClip: "text", color: "transparent", backgroundImage: "linear-gradient( to right, #FFFFD9, #856E4F )" }} className=" text-xl font-semibold font-Artemus ">Coming soon...</p>
            <div className="w-full bg-[#D9D9D921] rounded-full h-2 mt-3">
              <div className="w-[20%] rounded-full h-full bg-[#FFFFD9] "></div>
            </div>

            <div className="mt-3 flex justify-between items-center z-20 ">
              {/* <button className="z-20  bg-black rounded-full px-5 py-2 text-xs font-medium font-montserrat " 
              // onClick={() => setShowModal(true)}
              >
                {isSubscribed ? "Notified" : "Get Notified"}
              </button> */}
              {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-md z-50">
                  <div className="bg-[#1D1D1C] p-6 rounded-xl shadow-2xl w-96 text-center">
                    <h2 className="text-2xl font-semibold mb-4 text-white">Get Notified</h2>

                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                    />

                    <div className="flex justify-between mt-6">
                      <button
                        onClick={handleSubscribe}
                        className="bg-blue-600 text-white px-5 py-2.5 rounded-lg font-medium hover:bg-blue-700 transition-shadow shadow-md hover:shadow-lg"
                      >
                        Notify
                      </button>

                      <button
                        onClick={() => setShowModal(false)}
                        className="bg-gray-500 text-white px-5 py-2.5 rounded-lg hover:bg-gray-600 transition-shadow shadow-md hover:shadow-lg"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="relative">
                <p style={{ backgroundClip: "text", WebkitBackgroundClip: "text", color: "transparent", backgroundImage: "linear-gradient( to right, #FFFFD9, #856E4F )" }}
                  className=" absolute right-0 -top-1 font-semibold text-sm ">P2P</p>
                <img src="../assets/other/p2p.svg" className="h-10 pr-6 pt-1" />
              </div>

            </div>
          </div>

          {showLoader && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999, // Ensures overlay appears on top
                backdropFilter: "blur(5px)", // Apply blur effect to background
              }}
            >
              <div className="flex flex-col gap-4 justify-center items-center">
                <ClipLoader color="#ffffff" size={50} />
                <p style={{ color: "#ffffff", fontSize: "18px" }} className="text-center">
                  Loading...
                </p>
              </div>

            </div>
          )}

        </div>
        <Graph data={monthlyData} />
        <Table />
      </div>
    </div>
  );
};

export default Transactionhistory;
